import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";
import { Trans } from "@lingui/react/macro";

import Modal from "@mui/material/Modal";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import Link from "@readai/common/components/Link";
import useAuth from "@readai/common/hooks/useAuth";
import { withQueryParamsUrl } from "@readai/common/utils";
import Stack from "@readai/pulse/components/Stack";

import EventNotification, {
  EventNotificationAction,
  EventNotificationDescription,
  EventNotificationTitle,
} from "@app/booking/components/EventNotification";
import { NotificationCard } from "@app/booking/components/styles";
import ROUTES from "@app/booking/routes";

const Bubble = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.icon.neutral.default,
  borderRadius: theme.corners.base,
  padding: theme.spacing(1),
}));

const ACTIVATE_ACTION = {
  noUser: {
    href: withQueryParamsUrl(ROUTES.MAIN_APP.SIGN_IN, {
      redirectTo: ROUTES.MAIN_APP.SMART_SCHEDULER_SETTINGS,
    }),
    label: msg`Sign in to activate`,
  },
  user: {
    href: ROUTES.MAIN_APP.SMART_SCHEDULER_SETTINGS,
    label: msg`Activate`,
  },
};

const ActivateLinkModal = () => {
  const { user } = useAuth();
  const { _ } = useLingui();

  const action = user ? ACTIVATE_ACTION.user : ACTIVATE_ACTION.noUser;

  return (
    <Modal open disableAutoFocus>
      <Stack variant="center" sx={{ height: "100%", width: "100%" }}>
        <NotificationCard>
          <EventNotification>
            <Stack spacing={1}>
              <EventNotificationTitle>
                <Trans>This link hasn't been activated yet</Trans>
              </EventNotificationTitle>
              <EventNotificationDescription>
                {user ? (
                  <Trans>
                    If you're the owner of this link,{" "}
                    <Link href={action.href}>activate</Link> your link.
                  </Trans>
                ) : (
                  <Trans>
                    If you're the owner of this link, please{" "}
                    <Link href={action.href}>sign in</Link> to continue with
                    activation.
                  </Trans>
                )}
              </EventNotificationDescription>
            </Stack>
            <EventNotificationAction href={action.href}>
              {_(action.label)}
            </EventNotificationAction>
            <Bubble>
              <Typography variant="bodyPrimaryReg" color="text.med">
                <Trans>
                  Not the owner, but want your own Smart Scheduler link?{" "}
                  <Link href={ROUTES.MAIN_APP.SIGN_UP}>
                    Create a Read account
                  </Link>{" "}
                  to get started (free)!
                </Trans>
              </Typography>
            </Bubble>
          </EventNotification>
        </NotificationCard>
      </Stack>
    </Modal>
  );
};

export default ActivateLinkModal;
